import { Grid, Button, TextField, DataGrid } from "../../../../components";
import { format } from "date-fns";
import { SessionService, notification } from "../../../../services";
import { formatDate } from "../../../../utils";

const Observacoes = ({
  observacao,
  setObservacao,
  handleChangeObservacao,
  handleObservacao,
  removerObservacao,
  observacaoList,
}) => {
  const sessionService = new SessionService();
  const colunas = [
    {
      field: "nomeContato",
      headerName: "Contato",
      flex: 200,
    },
    {
      field: "observacao",
      headerName: "Observação",
      flex: 700,
    },
    {
      field: "updatedAt",
      headerName: "Data",
      flex: 200,
      valueGetter: (params) => 
        format(formatDate.received(params.value), "dd/MM/yyyy - HH:mm"),
    },
    {
      field: "insertUserName",
      headerName: "Usuário",
      flex: 200,
      valueGetter: (params) => params.value || sessionService.getUsuario().nome,
    },
  ];

  const handleEditObservacao = async (id) => {
    const result = observacaoList.filter((item) => item.id === id);
    setObservacao(result[0]);
  }

  const handleDeleteObservacao = async (id) => {
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      "Tem certeza que deseja excluir esta observação?"
    );
    if (retornoAlerta.isConfirmed) {
      removerObservacao(id);
    }
  };

  return (
    <form onSubmit={(e) => handleObservacao(e)}>
      <Grid container spacing={2} className="mt-3">
        <Grid item xs={3}>
          <TextField
            id="nomeContato"
            name="nomeContato"
            label="Nome do Contato"
            variant="outlined"
            required
            margin="normal"
            fullWidth
            value={observacao.nomeContato ?? ""}
            onChange={handleChangeObservacao}
          ></TextField>
        </Grid>
        <Grid item xs={8}>
          <TextField
            id="observacao"
            name="observacao"
            label="Observação"
            variant="outlined"
            required
            margin="normal"
            fullWidth
            value={observacao.observacao ?? ""}
            onChange={handleChangeObservacao}
          ></TextField>
        </Grid>
        <Grid item xs={1} className="d-flex align-items-center">
          <Button
            variant="contained"
            color="primary"
            size="large"
            type="submit"
            className="mt-2"
          >
            <i
              className={
                observacao.id
                  ? "ph-bold ph-arrows-clockwise" 
                  : "ph-fill ph-plus-circle"
              }
              style={{ color: "#fff", fontSize: 24 }}
            ></i>
          </Button>
        </Grid>
      </Grid>
      <Grid item xs={12} className="mt-4">
        <DataGrid
          rows={observacaoList}
          columns={colunas}
          editShow
          deleteShow
          onClickEdit={handleEditObservacao}
          onClickDelete={handleDeleteObservacao}
        />
      </Grid>
    </form>
  );
};

export default Observacoes;
